import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import LandingPage from "@/pages/LandingPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";

// Trademark Services
import TrademarkRegistration from "@/pages/services/TrademarkRegistration";
import TrademarkSearch from "@/pages/services/TrademarkSearch";
import ClearanceSearchServices from "@/pages/services/ClearanceSearchServices";
import TrademarkOwnershipTransfers from "@/pages/services/TrademarkOwnershipTransfers";
import StatementOfUse from "@/pages/services/StatementOfUse";
import TrademarkOfficeActions from "@/pages/services/TrademarkOfficeActions";
import TrademarkMonitoring from "@/pages/services/TrademarkMonitoring";
import TTABPetition from "@/pages/services/TTABPetition";

// Company Formation Services
import CompanyFormation from "@/pages/services/CompanyFormation";
import LLCFormation from "@/pages/services/LLCFormation";
import CCorporation from "@/pages/services/CCorporation";
import SCorporation from "@/pages/services/SCorporation";
import NonProfit from "@/pages/services/NonProfit";

// Copyright Services
import CopyrightRegistration from "@/pages/services/CopyrightRegistration";
import CopyrightEnforcement from "@/pages/services/CopyrightEnforcement";
import CopyrightTransfers from "@/pages/services/CopyrightTransfers";
import CopyrightLegalRepresentation from "@/pages/services/CopyrightLegalRepresentation";
import CopyrightPortfolioManagement from "@/pages/services/CopyrightPortfolioManagement";
import DMCACompliance from "@/pages/services/DMCACompliance";

// Patent Services
import PatentSearch from "@/pages/services/PatentSearch";
import PatentOfficeActions from "@/pages/services/PatentOfficeActions";
import PatentApplication from "@/pages/services/PatentApplication";
import PatentLegalRepresentation from "@/pages/services/PatentLegalRepresentation";

// Legal Services
import BusinessImmigrationLaw from "@/pages/services/BusinessImmigrationLaw";
import DueDiligenceProcess from "@/pages/services/DueDiligenceProcess";
import ITCommercialLaw from "@/pages/services/ITCommercialLaw";
import PartnershipsLLPs from "@/pages/services/PartnershipsLLPs";
import DataProtectionPrivacy from "@/pages/services/DataProtectionPrivacy";

// Additional Corporate Services
import AmazonBrandRegistry from "@/pages/services/AmazonBrandRegistry";
import BookkeepingService from "@/pages/services/BookkeepingService";
import BusinessFormationServices from "@/pages/services/BusinessFormationServices";
import CertificateGoodStanding from "@/pages/services/CertificateGoodStanding";
import CompanyDissolution from "@/pages/services/CompanyDissolution";
import CompanyNameChange from "@/pages/services/CompanyNameChange";
import CompanyRenewal from "@/pages/services/CompanyRenewal";
import IssueOfShares from "@/pages/services/IssueOfShares";
import NomineeDirectorSecretarial from "@/pages/services/NomineeDirectorSecretarial";
import TaxAdvisoryFiling from "@/pages/services/TaxAdvisoryFiling";
import TransferOfShares from "@/pages/services/TransferOfShares";
import CFOServices from "@/pages/services/CFOServices";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/lp" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          
          {/* Trademark Services */}
          <Route path="/services/trademark-registration" element={<TrademarkRegistration />} />
          <Route path="/services/trademark-search" element={<TrademarkSearch />} />
          <Route path="/services/clearance-search-services" element={<ClearanceSearchServices />} />
          <Route path="/services/trademark-ownership-transfers" element={<TrademarkOwnershipTransfers />} />
          <Route path="/services/statement-of-use" element={<StatementOfUse />} />
          <Route path="/services/trademark-office-actions" element={<TrademarkOfficeActions />} />
          <Route path="/services/trademark-monitoring" element={<TrademarkMonitoring />} />
          <Route path="/services/ttab-petition" element={<TTABPetition />} />
          
          {/* Company Formation Services */}
          <Route path="/services/company-formation" element={<CompanyFormation />} />
          <Route path="/services/llc-formation" element={<LLCFormation />} />
          <Route path="/services/c-corporation" element={<CCorporation />} />
          <Route path="/services/s-corporation" element={<SCorporation />} />
          <Route path="/services/non-profit" element={<NonProfit />} />
          
          {/* Copyright Services */}
          <Route path="/services/copyright-registration" element={<CopyrightRegistration />} />
          <Route path="/services/copyright-enforcement" element={<CopyrightEnforcement />} />
          <Route path="/services/copyright-transfers" element={<CopyrightTransfers />} />
          <Route path="/services/copyright-legal-representation" element={<CopyrightLegalRepresentation />} />
          <Route path="/services/copyright-portfolio-management" element={<CopyrightPortfolioManagement />} />
          <Route path="/services/dmca-compliance" element={<DMCACompliance />} />
          
          {/* Patent Services */}
          <Route path="/services/patent-search" element={<PatentSearch />} />
          <Route path="/services/patent-office-actions" element={<PatentOfficeActions />} />
          <Route path="/services/patent-application" element={<PatentApplication />} />
          <Route path="/services/patent-legal-representation" element={<PatentLegalRepresentation />} />
          
          {/* Legal Services */}
          <Route path="/services/business-immigration-law" element={<BusinessImmigrationLaw />} />
          <Route path="/services/due-diligence-process" element={<DueDiligenceProcess />} />
          <Route path="/services/it-commercial-law" element={<ITCommercialLaw />} />
          <Route path="/services/partnerships-llps" element={<PartnershipsLLPs />} />
          <Route path="/services/data-protection-privacy" element={<DataProtectionPrivacy />} />
          
          {/* Additional Corporate Services */}
          <Route path="/services/amazon-brand-registry" element={<AmazonBrandRegistry />} />
          <Route path="/services/bookkeeping-service" element={<BookkeepingService />} />
          <Route path="/services/business-formation-services" element={<BusinessFormationServices />} />
          <Route path="/services/certificate-good-standing" element={<CertificateGoodStanding />} />
          <Route path="/services/company-dissolution" element={<CompanyDissolution />} />
          <Route path="/services/company-name-change" element={<CompanyNameChange />} />
          <Route path="/services/company-renewal" element={<CompanyRenewal />} />
          <Route path="/services/issue-of-shares" element={<IssueOfShares />} />
          <Route path="/services/nominee-director-secretarial" element={<NomineeDirectorSecretarial />} />
          <Route path="/services/tax-advisory-filing" element={<TaxAdvisoryFiling />} />
          <Route path="/services/transfer-of-shares" element={<TransferOfShares />} />
          <Route path="/services/cfo-services" element={<CFOServices />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;